import React, { useEffect } from 'react';
import Shared from 'screens/shared';
import { actions } from 'redux/local';
import { useSelector } from 'react-redux';
import { _t } from 'utils';
import { DAYS, VALIDATION } from 'constant';

export default ({
  isCancel = false,
  onCancel,
  cluster: clusterEdit = {},
}) => {
  const { version = {} } = useSelector((e) => e);
  const { versions = [], default: defaultVersion } = version;
  const { id, properties = {} } = clusterEdit;
  if (properties.maintenanceWindow) {
    properties.dayOfTheWeek = properties.maintenanceWindow.dayOfTheWeek;
    properties.time = properties.maintenanceWindow.time;
    delete properties.maintenanceWindow;
  }

  const kubernetes = {
    name: '',
    k8sVersion: '',
    dayOfTheWeek: 'Monday',
    time: '12:00:00',
    ...properties,
  };

  const kubernetesFields = [
    {
      name: 'name',
      type: 'text',
      title: _t('Name'),
    },
    {
      name: 'k8sVersion',
      type: 'dropdown',
      title: _t('Version'),
      values: [],
    },
    {
      name: 'time',
      type: 'time',
      title: _t('Maintenance time'),
      // visible: !!id,
    },
    {
      name: 'dayOfTheWeek',
      type: 'dropdown',
      title: _t('Maintenance date'),
      values: DAYS,
      // visible: !!id,
    },
  ];

  const validations = [
    {
      name: 'name',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'name',
      type: VALIDATION.VARIABLE,
    },
    {
      name: 'name',
      type: VALIDATION.STRING,
      min: 3,
    },
    {
      name: 'name',
      type: VALIDATION.STRING,
      max: 63,
    },
    {
      name: 'k8sVersion',
      type: VALIDATION.REQUIRED,
    },
  ];

  useEffect(() => {
    actions.kubernetes.version.getAll();
    actions.kubernetes.version.getDefault();
  }, []);

  const onSave = ({
    name, k8sVersion, time, dayOfTheWeek,
  }) => {
    if (id) {
      actions.kubernetes.cluster.update({
        id,
        properties: {
          name,
          k8sVersion,
          maintenanceWindow: {
            time,
            dayOfTheWeek,
          },
        },
      });
      onCancel();
    } else {
      actions.kubernetes.cluster.create({
        properties: {
          name,
          k8sVersion,
          maintenanceWindow: {
            time,
            dayOfTheWeek,
          },
        },
      });
    }
  };

  const changeFields = [{
    name: 'k8sVersion',
    props: {
      values: versions
        .map((e) => (e === defaultVersion ? [e, `${e} (default)`] : e)),
    },
  }];

  return (
    <>
      <Shared.forms.Form
        fields={kubernetesFields}
        fieldsValues={kubernetes}
        changeFields={changeFields}
        onSubmit={onSave}
        isCancel={isCancel}
        onCancel={onCancel}
        validations={validations}
      />
    </>
  );
};
